import(/* webpackMode: "eager" */ "/opt/customer-accounts/src/app/error.tsx")